import React from 'react';
import BookingsList from './BookingsList';

const HomeVisitsList = () => {
  return (
    <BookingsList
      fixedVisitType="home_visit"
      pageTitle="الزيارات المنزلية"
      pageDescription="زيارة منزلية"
    />
  );
};

export default HomeVisitsList;
